module.exports = __webpack_public_path__ + "img/venus21.836d34ed.png";